import { ReactNode, TextareaHTMLAttributes } from 'react';
import { Path, useFormContext } from 'react-hook-form';

import ErrorMessage from '../ErrorMessage/ErrorMessage';
import TextArea from 'components/TextArea/TextArea';

type FormInputPropsT<FormValuesT> = TextareaHTMLAttributes<HTMLTextAreaElement> & {
  name: Path<FormValuesT> | string;
  label?: string | ReactNode;
  isRequired?: boolean;
};

const FormTextArea = <FormValuesT,>({ name, ...restProps }: FormInputPropsT<FormValuesT>) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  return (
    <>
      <TextArea {...register(name)} {...restProps} />
      {errors[name] && <ErrorMessage error={errors[name]?.message as Path<FormValuesT>} />}
    </>
  );
};

export default FormTextArea;
